import React from 'react'
import Checkmark from '../../components/svg/checkmark'
import classnames from 'classnames'
import HorizontalRule from '../../components/svg/horizontal-rule'

export const OptionCard = ({ children, className }) => {
  return (
    <div className={classnames('root', className)}>
      {children}
      <style jsx>{`
        .root {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          max-width: 49.4rem;
          border-radius: 1rem;
          box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.16);
          padding: 2.1rem 3.6rem 5.4rem;
          background: var(--secondary-bg-color);
        }

        @media (max-width: 1024px) {
          .root {
            padding: 2.1rem 3.6rem 3rem;
          }
        }
      `}</style>
    </div>
  )
}

export const CardTitle = ({ children }) => {
  return (
    <div className='root'>
      {children}
      <style jsx>{`
        .root {
          font-size: 2.2rem;
          font-weight: bold;
        }

        @media (max-width: 1024px) {
          .root {
            font-size: 1.6rem;
          }
        }
      `}</style>
    </div>
  )
}

export const CardIcon = ({ children }) => {
  return (
    <div className='root'>
      {children}
      <style jsx>{`
        .root {
          margin: 1.6rem 0 2.6rem;

          :global(svg) {
            height: 6rem;
            width: 6rem;
            fill: var(--secondary-button-bg);
          }
        }

        @media (max-width: 1024px) {
          .root {
            margin: 1.4rem 0 2rem;

            :global(svg) {
              height: 5rem;
              width: 5rem;
            }
          }
        }
      `}</style>
    </div>
  )
}

export const CardList = ({ children }) => {
  return (
    <div className='root'>
      {children}
      <style jsx>{`
        .root {
          margin-top: 4.8rem;
        }

        @media (max-width: 1024px) {
          .root {
            margin-top: 3rem;
          }
        }
      `}</style>
    </div>
  )
}

export const ListItem = ({ pros, children, className }) => {
  return (
    <div className='root'>
      <div className={classnames('icon', { pros })}>
        {pros ? <Checkmark /> : <HorizontalRule />}
      </div>
      <span className={classnames('text', className)}>{children}</span>

      <style jsx>{`
        .root {
          display: flex;
          align-items: center;
          padding: 1.7rem 0;

          &:not(:last-child) {
            border-bottom: 0.1rem solid var(--separator-line-color);
          }

          .text {
            font-size: 1.8rem;
            font-weight: bold;
            padding-left: 1.6rem;
          }

          .icon {
            :global(svg) {
              fill: var(--secondary-button-bg);
            }

            &.pros {
              :global(svg) {
                fill: var(--success-color);
                width: 2.1rem;
                height: 2.1rem;
              }
            }
          }
        }

        @media (max-width: 1024px) {
          .root {
            padding: 1.2rem 0;

            .text {
              font-size: 1.4rem;
              font-weight: bold;
              padding-left: 1.4rem;
            }

            .icon {
              :global(svg) {
                width: 1.8rem;
                height: 1.8rem;
              }
            }
          }
        }
      `}</style>
    </div>
  )
}
